import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaitempotraveller() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Tempo Traveller on Rent ',
    heading: 'Sanavi Travels: Pune to Mumbai Tempo Traveller on Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Mumbai Tempo Traveller on Rent, providing safe, comfortable, and hassle-free group travel for families, corporate teams, business travelers, tourists, and event groups traveling between Pune and Mumbai. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for corporate outings, weddings, airport transfers, sightseeing, and outstation travel, ensuring spacious seating, air-conditioned comfort, and ample luggage space. With experienced chauffeurs familiar with the Pune–Mumbai Expressway, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees a smooth, punctual, and comfortable journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to convenient drop-off anywhere in Mumbai such as South Mumbai, Andheri, Bandra, Navi Mumbai, and Thane, Sanavi Travels provides trusted Pune to Mumbai Tempo Traveller rental services for travelers seeking comfort, safety, and dependable intercity transportation.',

    top: 'Top Places to Visit in Mumbai with Sanavi Travels',


  "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most iconic landmark, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this grand basalt arch represents colonial-era architecture and historical significance. It serves as the starting point for ferries to Elephanta Caves and is especially vibrant in the evenings. The Gateway of India stands as a symbol of Mumbai’s rich history and maritime heritage."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the ‘Queen’s Necklace’, is a 3.6-kilometer-long coastal boulevard offering stunning views of the Arabian Sea. The curve of the promenade lights up beautifully at night, resembling a string of pearls. It is a favorite spot for evening walks, sunsets, and relaxation. Marine Drive perfectly captures Mumbai’s romantic and lively spirit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of the busiest railway stations in India. Built in Victorian Gothic architectural style, it features intricate stone carvings, domes, and stained glass windows. The station is both a functional transport hub and an architectural masterpiece. CSMT reflects Mumbai’s historical grandeur and daily urban rhythm."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves are ancient rock-cut caves located on Elephanta Island, a short ferry ride from Mumbai. Dating back to the 5th century, the caves are dedicated to Lord Shiva and feature magnificent sculptures, including the famous Trimurti. Surrounded by lush greenery, the site offers a blend of history, spirituality, and nature. Elephanta Caves are a UNESCO World Heritage Site and a must-visit attraction."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere and street food. Visitors enjoy local delicacies like vada pav, pav bhaji, and bhel puri while watching beautiful sunsets. The beach is also close to many Bollywood celebrity residences. Juhu Beach represents Mumbai’s vibrant local culture and seaside charm."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is an engineering marvel that connects the suburbs of Bandra with South Mumbai. Stretching over the Arabian Sea, it offers spectacular views, especially at night when illuminated. The sea link has become a modern symbol of Mumbai’s progress and infrastructure excellence. It is one of the city’s most photographed landmarks."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shri Siddhivinayak Temple is one of Mumbai’s most revered temples, dedicated to Lord Ganesha. Devotees from all walks of life, including celebrities and politicians, visit to seek blessings. The temple is known for its beautifully carved black stone idol and spiritual ambiance. Siddhivinayak Temple is a major center of faith and devotion in Mumbai."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a stunning mosque and tomb located on an islet off the coast of Worli. Connected by a narrow causeway, it is accessible only during low tide. The white marble structure against the sea creates a mesmerizing sight. Haji Ali Dargah symbolizes Mumbai’s religious harmony and architectural elegance."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market famous for shopping, cafes, and colonial-era charm. Visitors can shop for clothes, accessories, handicrafts, and souvenirs. The area is also home to iconic cafes and heritage buildings. Colaba Causeway offers a lively mix of shopping, culture, and local life."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green oasis located within Mumbai city limits. It is home to diverse wildlife, nature trails, and the ancient Kanheri Caves. The park offers a refreshing escape from urban life with activities like trekking and cycling. It highlights Mumbai’s unique balance between nature and metropolitan living."
  }
],




    "services": [
    {
      "name": "Pune to Mumbai Tempo Traveller on Rent",
      "description": "Pune to Mumbai Tempo Traveller on Rent provides reliable and comfortable vehicles for groups traveling between Pune and Mumbai. Well-maintained and spacious, these vehicles are ideal for family trips, corporate outings, or group tours. Professional drivers ensure safety and punctuality, while passengers enjoy a smooth journey on highways and city roads. Flexible booking options and transparent pricing make it convenient for travelers planning their trip from Pune to Mumbai."
    },
    {
      "name": "Mumbai Tempo Traveller Hire from Pune",
      "description": "Mumbai Tempo Traveller Hire from Pune offers flexible rental services for short or long trips between Pune and Mumbai. Vehicles are equipped for comfort with ample seating, luggage space, and air-conditioning. Experienced drivers manage routes efficiently, ensuring timely arrivals and a hassle-free journey. Perfect for sightseeing, corporate travel, or family vacations, this service provides convenience, reliability, and an enjoyable travel experience."
    },
    {
      "name": "AC Tempo Traveller Pune Mumbai",
      "description": "AC Tempo Traveller Pune Mumbai provides air-conditioned vehicles for a cool and comfortable journey between Pune and Mumbai. Ideal for long-distance travel, family vacations, or corporate trips, these vehicles offer spacious seating and luggage-friendly interiors. Professional chauffeurs ensure safe driving and optimized routes for a smooth and pleasant journey, allowing passengers to relax and enjoy the trip without stress."
    },
    {
      "name": "Luxury Tempo Traveller Pune to Mumbai",
      "description": "Luxury Tempo Traveller Pune to Mumbai offers premium, well-appointed vehicles for a comfortable and elegant travel experience. Ideal for VIP trips, corporate travel, or special family outings, these vehicles provide reclining seats, entertainment options, and ample luggage space. Professional drivers ensure punctual and safe transfers, making the journey convenient, stylish, and enjoyable."
    },
    {
      "name": "Corporate Tempo Traveller Mumbai",
      "description": "Corporate Tempo Traveller Mumbai caters to business travelers and office groups commuting between Pune and Mumbai. Vehicles are equipped with premium interiors, spacious seating, and amenities for work or relaxation during travel. Chauffeurs maintain punctuality and safety, allowing employees or executives to focus on their tasks or rest. Flexible billing and booking options make this service ideal for corporate needs."
    },
    {
      "name": "Family Tempo Traveller Mumbai",
      "description": "Family Tempo Traveller Mumbai ensures safe and comfortable travel for families commuting between Pune and Mumbai. Vehicles provide ample seating, luggage space, and child-friendly features for long-distance travel. Experienced drivers follow safe routes, ensuring a stress-free journey. Perfect for weekend trips, vacations, or family visits, this service prioritizes convenience, safety, and passenger comfort."
    },
    {
      "name": "Airport Transfer Tempo Traveller Mumbai",
      "description": "Airport Transfer Tempo Traveller Mumbai provides timely pickups and drop-offs at Mumbai airports for groups traveling from Pune. Vehicles are spacious, comfortable, and luggage-friendly, ideal for travelers with bags or large groups. Professional drivers ensure punctual arrivals and a hassle-free experience, making airport transfers smooth, safe, and reliable."
    },
    {
      "name": "Affordable Pune to Mumbai Tempo Traveller",
      "description": "Affordable Pune to Mumbai Tempo Traveller offers budget-friendly travel options for groups without compromising on comfort or safety. Well-maintained vehicles, professional drivers, and spacious seating ensure a stress-free journey. Perfect for family trips, friends traveling together, or corporate groups seeking economical transport, this service combines affordability with reliability."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Mumbai",
      "description": "Chauffeur Driven Tempo Traveller Mumbai provides professional drivers for a hassle-free journey between Pune and Mumbai. Passengers can relax while experienced chauffeurs handle the routes and traffic, ensuring safety and punctuality. Spacious and comfortable vehicles accommodate families, friends, or corporate groups, offering convenience and peace of mind throughout the journey."
    },
    {
      "name": "Group Travel Tempo Traveller Pune Mumbai",
      "description": "Group Travel Tempo Traveller Pune Mumbai caters to large groups commuting between Pune and Mumbai. Vehicles are spacious, well-maintained, and equipped for long-distance travel, providing comfort for all passengers. Professional drivers manage the journey efficiently, ensuring timely arrivals and a smooth experience. Ideal for corporate groups, school trips, or family outings, this service guarantees reliable and enjoyable travel."
    },
    {
      "name": "Best Tempo Traveller Pune to Mumbai",
      "description": "Best Tempo Traveller Pune to Mumbai offers top-quality vehicles and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth journey. Suitable for families, friends, and corporate travelers, this service emphasizes punctuality, safety, and comfort while traveling between Pune and Mumbai."
    },
    {
      "name": "Tempo Traveller One Day Trip Mumbai",
      "description": "Tempo Traveller One Day Trip Mumbai provides vehicles for short trips or day tours from Pune to Mumbai. Ideal for sightseeing, corporate events, or family outings, these vehicles offer comfort, ample space, and reliable service. Professional drivers ensure timely pick-ups and drop-offs, making day trips efficient, convenient, and enjoyable for all passengers."
    },
    {
      "name": "Tempo Traveller Rental Service Pune",
      "description": "Tempo Traveller Rental Service Pune offers reliable vehicles for long-distance travel between Pune and Mumbai. Spacious, comfortable, and well-maintained, these vehicles are suitable for families, corporate groups, or friends traveling together. Professional drivers ensure safety, punctuality, and a stress-free journey, while flexible booking options provide convenience and peace of mind for passengers."
    },
    {
      "name": "Business Travel Tempo Traveller",
      "description": "Business Travel Tempo Traveller caters to executives and corporate groups commuting between Pune and Mumbai. Vehicles provide comfortable seating, workspace amenities, and a smooth ride for productive travel. Professional chauffeurs ensure punctuality and safe driving, allowing business travelers to rest or work during the journey. Ideal for meetings, conferences, or corporate trips, this service combines comfort, efficiency, and reliability."
    },
    {
      "name": "Pune Mumbai Travel Vehicle",
      "description": "Pune Mumbai Travel Vehicle provides dependable and comfortable transport for individuals and groups traveling between Pune and Mumbai. Vehicles are spacious, equipped for long-distance comfort, and maintained for safety. Experienced drivers handle traffic and highway routes, ensuring a smooth, stress-free journey. Perfect for family trips, friends traveling together, or corporate commuters, this service guarantees a reliable and enjoyable travel experience."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Tempo Traveller on Rent", "Mumbai Tempo Traveller Hire from Pune"],
    ["AC Tempo Traveller Pune Mumbai", "Luxury Tempo Traveller Pune to Mumbai"],
    ["Corporate Tempo Traveller Mumbai", "Family Tempo Traveller Mumbai"],
    ["Airport Transfer Tempo Traveller Mumbai", "Affordable Pune to Mumbai Tempo Traveller"],
    ["Chauffeur Driven Tempo Traveller Mumbai", "Group Travel Tempo Traveller Pune Mumbai"],
    ["Best Tempo Traveller Pune to Mumbai", "Tempo Traveller One Day Trip Mumbai"],
    ["Tempo Traveller Rental Service Pune", "Business Travel Tempo Traveller"],
    ["Pune Mumbai Travel Vehicle", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Tempo Traveller on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Pune to Mumbai Tempo Traveller on rent services, ideal for corporate travel, family trips, group tours, and comfortable intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Travel from Pune to Mumbai in spacious, air-conditioned, and well-maintained Tempo Travellers for a smooth and relaxing group journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune to Mumbai Route",
    "WhyChoosedescription": "Our professional drivers are well-experienced with the Pune to Mumbai expressway route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Mumbai Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and trip coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Tempo Traveller rental plans for your Pune to Mumbai journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mumbai Tempo Traveller on rent."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Mumbai Tempo Traveller on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune to Mumbai travel.'
  },
  {
    question: 'How can I book a Pune to Mumbai Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Pune to Mumbai Tempo Traveller?',
    answer: 'We offer Tempo Travellers with different seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included in the Tempo Traveller rental?',
    answer: 'Yes, all Tempo Traveller rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the Pune to Mumbai Tempo Traveller service available 24x7?',
    answer: 'Yes, our Pune to Mumbai Tempo Traveller service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the Pune to Mumbai trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I book a round-trip Tempo Traveller from Pune to Mumbai?',
    answer: 'Absolutely. Sanavi Travels offers one-way and round-trip Tempo Traveller rental options.'
  },
  {
    question: 'What payment options are available for Pune to Mumbai Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the Pune to Mumbai journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Booked a Pune to Mumbai Tempo Traveller with Sanavi Travels. Clean vehicle, punctual service, and very professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Verma',
    feedback: 'Excellent experience with Sanavi Travels. Smooth ride and comfortable Tempo Traveller for our group.',
    rating: 5
  }
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Tempo Traveller On Rent - Sanavi Travels",
  "description": "Pune to Mumbai tempo traveller on rent by Sanavi Travels for corporate travel, family trips, business travel, airport transfers, and group journeys. Choose AC and luxury tempo travellers for a comfortable and affordable Pune to Mumbai travel experience.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4689"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Mumbai Tempo Traveller On Rent Starting from ₹30 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Mumbai tempo traveller on rent with Sanavi Travels. AC and luxury tempo traveller for corporate travel, airport transfer, family and group trips at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaitempotraveller;